<!-- <dg-file-upload
  *ngIf="prePath"
  [edit]="true"
  [previousPath]="prePath"
  [isPreview]="true"
  [allowUpdate]="true"
  [allowMerging]="false"
  [viewAttach]="true"
  [withActions]="true"
  [encryptedAttchId]="true"
  [refreshAttachComponent]="true"
  (onPreviewClose)="onPreviewClose()"
></dg-file-upload>
<dg-file-upload
  *ngIf="attachId && !mappingId"
  [edit]="true"
  [attachId]="attachId"
  [isPreview]="true"
  [allowUpdate]="true"
  [allowMerging]="false"
  [viewAttach]="true"
  [withActions]="true"
  [encryptedAttchId]="true"
  [refreshAttachComponent]="true"
  (onPreviewClose)="onPreviewClose()"
></dg-file-upload>

<dg-file-upload
  *ngIf="attachId && mappingId"
  [edit]="true"
  [attachId]="attachId"
  [isPreview]="true"
  [allowUpdate]="true"
  [allowMerging]="false"
  [viewAttach]="true"
  [withActions]="true"
  [mappingId]="mappingId"
  [refreshAttachComponent]="true"
  (onPreviewClose)="onPreviewClose()"
></dg-file-upload> -->
<dg-file-upload *ngIf="prePath" [edit]="true" [previousPath]="prePath" [isPreview]="true" [allowUpdate]="true"
  [isDownload]="true" [allowMerging]="false" [viewAttach]="true" [withActions]="true" [refreshAttachComponent]="true"
  (onPreviewClose)="onPreviewClose()"></dg-file-upload>
<dg-file-upload *ngIf="attachId && !mappingId" [edit]="true" [attachId]="attachId" [isPreview]="true"
  [allowUpdate]="true" [isDownload]="true" [allowMerging]="false" [viewAttach]="true" [withActions]="true"
  [refreshAttachComponent]="true" (onPreviewClose)="onPreviewClose()"></dg-file-upload>
<dg-file-upload *ngIf="attachId && mappingId" [edit]="true" [attachId]="attachId" [title]="nameInput" [isPreview]="true"
  [allowUpdate]="true" [isDownload]="true" [allowMerging]="false" [viewAttach]="true" [withActions]="true"
  [mappingId]="mappingId" [shwPreviewInWindow]="true" [refreshAttachComponent]="true"
  (onPreviewClose)="onPreviewClose()"></dg-file-upload>